<template>
  <div class="manage-roles">
    <div class="modal manage-roles-modal" style="position: absolute !important">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />
      <div class="modal-card has-text-left">
        <section class="modal-card-body">
          <p class="header" @click="showWorkflowInfo">
            Roles Info
            <strong class="tag is-pulled-right">{{ shortWorkflowID }}</strong>
          </p>
          <div v-if="roles">
            <a
              class="panel-block"
              v-for="r in roles"
              :key="r.id"
              @click="moreInfo(r)"
            >
              <span class="panel-icon" style="width: 10px">
                <i :class="roleIcon(r)" :style="roleStyle(r)" />
              </span>
              <span v-if="r.user">
                {{ r.user.name }}
                <span class="tag is-black is-medium">{{
                  r.user.phone_number
                }}</span>
                <span class="tag is-warning is-medium">{{ r.role_name }}</span>
              </span>
              <span v-if="!r.user">
                Unclaimed
                <strong>{{ r.phone_number }}</strong>
              </span>
              <i
                v-if="!r.user"
                class="far fa-times-circle"
                style="margin-left: 6px"
              />
            </a>
          </div>
          <div v-else style="margin: 40px; text-align: center">
            <p v-if="loading">
              <i class="fa fa-atom fa-spin fa-10x" />
            </p>
            <p v-else class="tag is-large is-dark">No Roles</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "ManageRolesModal",
  components: {},
  data() {
    return {
      roles: null,
      workflow: null,
      loading: true,
    };
  },
  computed: {
    shortWorkflowID() {
      if (!this.workflow) return "";
      return this.workflow.id.substr(this.workflow.id.length - 5);
    },
  },
  created() {},
  mounted() {
    EventBus.$on("MANAGE_ROLES", (w) => {
      console.log("MANAGE_ROLES, workflow:", w);
      this.roles = null; // reset
      this.loading = true;
      this.workflow = w; // set this workflow
      this.getRolesInfo();
    });
  },
  beforeDestroy() {
    EventBus.$off("MANAGE_ROLES");
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    showWorkflowInfo() {
      this.$swal({
        title: "Workflow ID",
        text: this.workflow.id,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    getRolesInfo() {
      var workflowID = this.workflow.id;
      // var loader = this.loadingDots();
      this.$store
        .dispatch("getRolesByWorkflow", workflowID)
        .then((res) => {
          console.log("getRolesByWorkflow", res.data);
          this.roles = res.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    roleStyle(r) {
      var color = "red";
      if (r.state === "working") color = "lightgreen";
      if (r.user_id === "") color = "grey";
      return `color: ${color}`;
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    roleIcon(r) {
      if (r.role_name === "Driver") return "fas fa-shuttle-van";
      if (r.role_name === "Dispatcher") return "fas fa-phone-volume";
      if (r.role_name === "Free") return "fa fa-gift";
      return "fas fa-user"; // question
    },
    preDeleteUnclaimedRole(r) {
      this.deleteWorkerRole(r);
      this.successToast("Deleted unclaimed role!");
    },
    moreInfo(r) {
      if (!r.user) {
        this.preDeleteUnclaimedRole(r);
        return;
      }
      var shortID = this.lastFive(r.id);
      var t = new Date(r.updated_at);
      var timeDiff = Math.round((new Date() - t) / (1000 * 60));
      var prettyTime = `${timeDiff} mins ago`;
      if (timeDiff > 60) {
        timeDiff = Math.round(timeDiff / 60);
        prettyTime = `${timeDiff} hours ago`;
      }
      var prettyLoc = "4 mins ago";
      this.$swal({
        title: r.user ? r.user.name : "Unclaimed",
        html: `<div style='text-align:left'>
        Role name <strong>${r.role_name}</strong><br>
        Role ID <strong>${shortID}</strong><br>
        Role updated <strong>${prettyTime}</strong><br>
        Source <strong>${r.user.source}</strong>
        </div>`,
        // <br>Location updated <strong>${prettyLoc}</strong>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonText: "Edit",
      }).then((result) => {
        console.log(result);
        if (result.dismiss === "cancel") {
          this.deleteWorkerRole(r);
        }
      });
    },
    deleteWorkerRole(r) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", r.id) // should soft delete
        .then((res) => {
          this.console("deleteWorkerRole", res);
          this.getRolesInfo();
        })
        .catch((err) => console.error(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.header {
  font-size: 1.3em;
  margin-left: 4px;
  margin-bottom: 4px;
}
.panel-block {
  font-size: 1.15em;
  white-space: nowrap;
  overflow: auto;
  /* border-radius: 25px; */
  border: 1px solid #dbdbdb;
  margin-bottom: -1px;
  padding: 4px 8px;
}
.panel-block::-webkit-scrollbar {
  display: none;
}
.distance {
  font-size: 0.75em;
  color: grey !important;
}
.modal-card-body {
  padding: 12px;
  /* border-radius: 25px; */
}
</style>